<!-- <div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div> -->
<div
  *ngIf="!isLoading"
  class="igntr-theme bg-[--background-color] md:mt-0 min-h-[calc(100vh-128px)] md:min-h-[100vh]"
>
  <div class="bg-white border-b !border-slate-200" *ngIf="tenant">
    <div class="max-w-[1180px] mx-auto p-4">
      <div class="flex items-start gap-4 flex-wrap">
        <div
          class="w-16 h-16 rounded-2xl flex items-center justify-center text-[14px] font-semibold !text-slate-700 border !border-slate-200"
          style="background: oklch(0.96 0.02 125)"
        >
          {{ getInitials(tenant.name) }}
        </div>
        <div class="flex-1 min-w-[160px]">
          <div class="text-[36px] font-semibold !text-slate-900 tracking-tight">
            {{ tenant.name }}
          </div>
          <div class="flex items-center gap-3 mt-1.5">
            <span
              class="inline-flex items-center gap-1.5 text-[14px] !text-slate-600 shrink-0"
            >
              <span
                class="w-1.5 h-1.5 rounded-full shrink-0"
                [ngClass]="tenant.isDisabled ? 'bg-red-500' : 'bg-emerald-500'"
              >
              </span>
              {{
                tenant.isDisabled
                  ? ("disabled" | transloco)
                  : ("active" | transloco)
              }}
            </span>
            <!-- <span
              class="inline-flex items-center px-1.5 py-0.5 rounded text-[10.5px] border bg-[oklch(0.96_0.02_150)] text-[oklch(0.38_0.10_150)] border-[oklch(0.88_0.05_150)]"
            >
              {{ "internal" | transloco }}
            </span> -->
            <span class="font-mono text-[14px] !text-slate-400 shrink-0">
              {{ formatText(tenant.name) }}
            </span>
            <span class="!text-slate-300 hidden md:flex"> · </span>
            <span
              class="font-mono text-[14px] !text-slate-500 hidden md:flex shrink-0"
            >
              {{ "created" | transloco }}
              {{ tenant.createdAt | date: "dd-MM-yyyy HH:mm" }}
            </span>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-2 w-[360px] shrink-0 max-w-full">
          <div class="rounded-lg border !border-slate-200/70 px-3 py-2">
            <div class="text-[14px] uppercase tracking-[0.1em] !text-slate-400">
              {{ "users" | transloco }}
            </div>
            <div
              class="font-mono text-[14px] tabular-nums !text-slate-900 mt-0.5"
            >
              {{ tenant.countOfUsers }}
            </div>
          </div>
          <!-- <div class="rounded-lg border !border-slate-200/70 px-3 py-2">
            <div class="text-[10px] uppercase tracking-[0.1em] !text-slate-400">
              {{ "plan" | transloco }}
            </div>
            <div
              class="font-mono text-[15px] tabular-nums !text-slate-900 mt-0.5"
            >
              {{ "internal" | transloco }}
            </div>
          </div> -->
          <div class="rounded-lg border !border-slate-200/70 px-3 py-2">
            <div class="text-[14px] uppercase tracking-[0.1em] !text-slate-400">
              {{ "status" | transloco }}
            </div>
            <div
              class="font-mono text-[14px] tabular-nums !text-slate-900 mt-0.5"
            >
              {{
                tenant.isDisabled
                  ? ("disabled" | transloco)
                  : ("active" | transloco)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-[1180px] mx-auto px-4 md:hidden">
      <app-datalist-select
        [activeValue]="selectedTab"
        [options]="tabsOptions"
        [multiple]="false"
        [clearable]="false"
        (activeValueChange)="changeTabs($event)"
      ></app-datalist-select>
    </div>

    <div
      class="max-w-[1180px] mx-auto px-4 items-center gap-0.5 overflow-x-auto overflow-y-hidden whitespace-nowrap hidden md:flex custom-scrollbar"
      role="group"
    >
      <button
        class="px-2 py-2 text-[14px] font-medium transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'home'"
        [ngClass]="
          selectedTab === 'home'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'home'"
      >
        <igntr-icon name="home"></igntr-icon>
        {{ "home" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'information' || !id"
        [class.active]="selectedTab === 'information'"
        [ngClass]="
          selectedTab === 'information'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'information'"
      >
        <igntr-icon name="info"></igntr-icon>

        {{ "info" | transloco }}
      </button>

      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'spDescription' || !id"
        [class.active]="selectedTab === 'spDescription'"
        [ngClass]="
          selectedTab === 'spDescription'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'spDescription'"
      >
        <igntr-icon name="database"></igntr-icon>

        {{ "spDescription" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'description' || !id"
        [class.active]="selectedTab === 'description'"
        [ngClass]="
          selectedTab === 'description'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'description'"
      >
        <igntr-icon name="sparkle"></igntr-icon>

        {{ "description" | transloco }}
      </button>
      @if (tenantHasQuestionnaire) {
        <button
          class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
          [disabled]="selectedTab === 'questionnaire' || !id"
          [class.active]="selectedTab === 'questionnaire'"
          [ngClass]="
            selectedTab === 'questionnaire'
              ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
              : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
          "
          (click)="selectedTab = 'questionnaire'"
        >
          <igntr-icon name="bulb"></igntr-icon>

          {{ "questionnaire" | transloco }}
        </button>
      }
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'tags' || !id"
        [class.active]="selectedTab === 'tags'"
        [ngClass]="
          selectedTab === 'tags'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'tags'"
      >
        <igntr-icon name="tag"></igntr-icon>

        {{ "tags" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'folders' || !id"
        [class.active]="selectedTab === 'folders'"
        [ngClass]="
          selectedTab === 'folders'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'folders'"
      >
        <igntr-icon name="folder"></igntr-icon>

        {{ "folders" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'teams' || !id"
        [class.active]="selectedTab === 'teams'"
        [ngClass]="
          selectedTab === 'teams'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'teams'"
      >
        <igntr-icon name="users"></igntr-icon>

        {{ "teams" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'departments' || !id"
        [class.active]="selectedTab === 'departments'"
        [ngClass]="
          selectedTab === 'departments'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'departments'"
      >
        <igntr-icon name="building"></igntr-icon>

        {{ "departments" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'checklists' || !id"
        [class.active]="selectedTab === 'checklists'"
        [ngClass]="
          selectedTab === 'checklists'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'checklists'"
      >
        <igntr-icon name="check"></igntr-icon>

        {{ "checklists" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'msGraphOptions' || !id"
        [class.active]="selectedTab === 'msGraphOptions'"
        [ngClass]="
          selectedTab === 'msGraphOptions'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'msGraphOptions'"
      >
        <igntr-icon name="globe"></igntr-icon>

        {{ "msGraphOptions" | transloco }}
      </button>
      <button
        class="px-2 py-2 text-[14px] font-medium border-b-2 transition-colors -mb-px inline-flex items-center gap-1.5 shrink-0 border-solid"
        [disabled]="selectedTab === 'emailTemplates' || !id"
        [class.active]="selectedTab === 'emailTemplates'"
        [ngClass]="
          selectedTab === 'emailTemplates'
            ? 'border-b-2 border-[var(--primary-color)] !text-slate-90'
            : 'border-b-2 border-transparent !text-slate-500 hover:!text-slate-800'
        "
        (click)="selectedTab = 'emailTemplates'"
      >
        <igntr-icon name="bell"></igntr-icon>

        {{ "emailTemplates" | transloco }}
      </button>
    </div>
  </div>

  <div [ngSwitch]="selectedTab">
    <div *ngSwitchCase="'home'">
      <!-- <h2 class="mt-4 mb-4" *ngIf="!id" i18n="Create tenant label">
        {{ "createTenant" | transloco }}
      </h2>
      <h2 class="mt-4 mb-4" *ngIf="id" i18n="Edit tenant label">
        {{ "editTenant" | transloco }}
      </h2> -->

      <div *ngIf="tenant">
        <app-tenant-form
          *ngIf="!(featureRepo.isLoading$ | async)"
          [editedTenant]="tenant"
          [features]="featureRepo.all$ | async"
          [isSaving]="isSaving"
          (tenantSubmit)="createTenant($event)"
        ></app-tenant-form>
        <h2 *ngIf="featureRepo.isLoading$ | async">
          <app-spinner></app-spinner>
        </h2>
        <app-error-alert
          title="{{ 'couldNotSubmitTheTenantProfile' | transloco }}"
          i18n-title="Tenant profile submit error alert"
          [errors]="submitErrors"
        ></app-error-alert>
      </div>
    </div>

    <app-tenant-edithtml-page
      *ngSwitchCase="'information'"
      [tenant]="tenant"
      [id]="id ?? null"
      (saved)="reloadTenant()"
    ></app-tenant-edithtml-page>

    <app-tenant-sp-description
      *ngSwitchCase="'spDescription'"
    ></app-tenant-sp-description>

    <app-tenant-description-form
      *ngSwitchCase="'description'"
      [tenant]="tenant"
    ></app-tenant-description-form>

    <app-tenant-tags *ngSwitchCase="'tags'" [tenantId]="id!"></app-tenant-tags>

    <app-tenant-folders
      *ngSwitchCase="'folders'"
      [tenantId]="id!"
    ></app-tenant-folders>

    <app-tenant-teams *ngSwitchCase="'teams'" [tenantId]="id!"></app-tenant-teams>

    <app-tenant-departments
      *ngSwitchCase="'departments'"
      [tenantId]="id!"
    ></app-tenant-departments>

    <app-checklist-page *ngSwitchCase="'checklists'"></app-checklist-page>

    <app-tenant-emails-list-page
      *ngSwitchCase="'msGraphOptions'"
    ></app-tenant-emails-list-page>

    <app-tenant-email-template
      *ngSwitchCase="'emailTemplates'"
    ></app-tenant-email-template>

    <app-tenant-questionnaire
      *ngSwitchCase="'questionnaire'"
      [id]="tenantHasQuestionnaire ? (id ?? null) : null"
    ></app-tenant-questionnaire>
  </div>

  <div *ngIf="!tenant">
    <div class="max-w-[1180px] mx-auto p-4">
      <app-page-hero [title]="'createTenant'"></app-page-hero>
      <app-tenant-form
        *ngIf="!(featureRepo.isLoading$ | async)"
        [features]="featureRepo.all$ | async"
        [isSaving]="isSaving"
        (tenantSubmit)="createTenant($event)"
      ></app-tenant-form>
      <h2 *ngIf="featureRepo.isLoading$ | async">
        <app-spinner></app-spinner>
      </h2>
      <app-error-alert
        title="{{ 'couldNotSubmitTheTenantProfile' | transloco }}"
        i18n-title="Tenant profile submit error alert"
        [errors]="submitErrors"
      ></app-error-alert>
    </div>
  </div>
</div>
